import React from 'react';
import './PublicScreener.css'; // reuse the ps-* chrome (brand fonts, dark theme)

// Clean "create a free account" screen shown to anonymous visitors who hit a
// deep, account-only feature directly (LoginGate routes gated paths here). Its
// own minimal chrome — the shared app nav is never shown to logged-out users.
const FEATURE_LABELS = {
  '/portfolio': 'build and grade your portfolio',
  '/alpha': 'talk to Alpha, your AI analyst',
  '/watchlists': 'create and save watchlists',
  '/news': 'see the latest news on the stocks you own and watch',
  '/model-portfolios': 'follow the model portfolios AlphaGrade trades on its own grades',
  '/grade-watch': 'get grade-change alerts',
  '/correlations': 'explore correlations',
  '/research': 'use Market Research',
};

// Some of these pages are not, in fact, free once you have the account, and a
// gate that says "create a free account to X" and then hands you an upgrade
// wall is worse than one that was honest up front. Where a paid tier is
// genuinely required, say so here rather than discovering it after signup.
const PLAN_NOTES = {
  '/alpha': 'Every account can ask Alpha about a stock. The Alpha Workspace itself, with saved threads and live research, is a Premium feature.',
  '/correlations': 'Correlation mapping itself is a Premium feature. The account is still free, and everything listed above comes with it.',
};

export default function SignupGate({ path, onSignIn, onGetStarted }) {
  const key = Object.keys(FEATURE_LABELS).find((p) => (path || '').startsWith(p));
  const what = FEATURE_LABELS[key] || 'use this feature';
  const planNote = PLAN_NOTES[key];

  return (
    <div className="ps">
      <header className="ps-nav">
        <div className="ps-brand">
          <span className="ps-logo">AG</span>
          <span className="ps-brandname">Alpha<b>Grade</b></span>
        </div>
        <div className="ps-nav-actions">
          <button className="ps-signin" onClick={onSignIn}>Sign in</button>
          <button className="ps-getstarted" onClick={onGetStarted}>Get started free</button>
        </div>
      </header>

      <div className="ps-body" style={{ textAlign: 'center', paddingTop: '2.5rem' }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🔒</div>
        <h1 className="ps-title">Create a free account to {what}</h1>
        <p className="ps-sub" style={{ margin: '0 auto 1.25rem', maxWidth: 440 }}>
          It’s free — no credit card. Grade any stock, save a portfolio, build watchlists, and ask Alpha.
        </p>
        {planNote && (
          <p className="ps-sub" style={{ margin: '-0.5rem auto 1.25rem', maxWidth: 440, opacity: 0.75 }}>
            {planNote}
          </p>
        )}
        <button className="ps-getstarted lg" onClick={onGetStarted}>Create your free account →</button>
        <div style={{ marginTop: '1.1rem' }}>
          <button className="ps-signin" onClick={() => { window.location.href = '/screener'; }}>
            Or grade a stock free →
          </button>
        </div>
        <div style={{ marginTop: '2rem' }}>
          <a href="/" style={{ color: '#64748B', fontSize: '0.85rem', textDecoration: 'none' }}>← Back to the dashboard</a>
        </div>
      </div>

      <footer className="ps-foot">
        AlphaGrade is for research and education, not financial advice.
      </footer>
    </div>
  );
}
